import { ReactNode } from 'react'
import { Button } from 'react-aria-components'
import { ObjectProperty } from '../../shared/types'
import { useListContext } from './list-context'

type ListHeaderProps = {
	children: ReactNode
	sortBy: string
	type?: ObjectProperty['type']
}

const DIRECTION = {
	ASC: {
		invert: 'DESC',
		symbol: '↑',
	},
	DESC: {
		invert: 'ASC',
		symbol: '↓',
	},
} as const

export function ListHeader({ children, sortBy, type }: ListHeaderProps) {
	const { params, setParams } = useListContext()
	const { invert, symbol } = DIRECTION[params.orderDir]
	const isActive = params.orderKey === sortBy
	const onClick = () => {
		setParams({
			orderKey: sortBy,
			orderDir: isActive ? invert : 'ASC',
			page: 1,
		})
	}

	return (
		<th className={type === 'currency' ? 'text-right' : undefined}>
			<Button
				onPress={onClick}
				className="outline-0 underline underline-offset-2 decoration-dotted"
			>
				{children} {isActive ? symbol : null}
			</Button>
		</th>
	)
}
